/**
 * Generál egy SEO-barát slug-ot a megadott szövegből
 * @param text - A szöveg, amiből slug-ot készítünk
 * @returns URL-barát slug
 */
export const slugify = (text: string): string => {
  return text
    .toString()
    .toLowerCase()
    .trim()
    // Magyar karakterek cseréje
    .replace(/á/g, 'a')
    .replace(/é/g, 'e')
    .replace(/í/g, 'i')
    .replace(/ó/g, 'o')
    .replace(/ö/g, 'o')
    .replace(/ő/g, 'o')
    .replace(/ú/g, 'u')
    .replace(/ü/g, 'u')
    .replace(/ű/g, 'u')
    // Szóközök és speciális karakterek cseréje kötőjelre
    .replace(/\s+/g, '-')
    .replace(/[^\w-]+/g, '')
    .replace(/--+/g, '-')
    .replace(/^-+/, '')
    .replace(/-+$/, '');
};

/**
 * Generál egy egyedi slug-ot járműhöz
 * @param make - Márka
 * @param model - Modell
 * @param year - Évjárat
 * @param suffix - Opcionális egyedi azonosító (pl. utolsó 4 karakter az ID-ból)
 * @returns Egyedi slug (pl. "porsche-cayenne-2024-a1b2")
 */
export const generateVehicleSlug = (
  make: string,
  model: string,
  year: number,
  suffix?: string
): string => {
  const baseSlug = slugify(`${make} ${model} ${year}`);
  return suffix ? `${baseSlug}-${suffix}` : baseSlug;
};
